import { message } from 'antd';
import defaultSettings from '../defaultSettings';
import Horn from '@mtfe/horn-sdk';
import { produce } from 'immer';
import { initOwl } from '@/utils/owl';

let lessNodesAppended;
const updateTheme = primaryColor => {
  // // Don't compile less in production!
  /* eslint-disable */
  if (APP_TYPE !== 'site') {
    return;
  }
  /* eslint-disable */
  // Determine if the component is remounted
  if (!primaryColor) {
    return;
  }
  const hideMessage = message.loading('正在编译主题！', 0);
  function buildIt() {
    if (!window.less) {
      return;
    }
    setTimeout(() => {
      window.less
        .modifyVars({
          '@primary-color': primaryColor,
        })
        .then(() => {
          hideMessage();
        })
        .catch(() => {
          message.error('Failed to update theme');
          hideMessage();
        });
    }, 200);
  }
  if (!lessNodesAppended) {
    const lessStyleNode = document.createElement('link');
    const lessConfigNode = document.createElement('script');
    const lessScriptNode = document.createElement('script');
    lessStyleNode.setAttribute('rel', 'stylesheet/less');
    // lessStyleNode.setAttribute('href', '/color.less');
    lessConfigNode.innerHTML = `
      window.less = {
        async: true,
        env: 'production',
        javascriptEnabled: true
      };
    `;
    lessScriptNode.src = 'https://gw.alipayobjects.com/os/lib/less.js/3.8.1/less.min.js';
    lessScriptNode.async = true;
    lessScriptNode.onload = () => {
      buildIt();
      lessScriptNode.onload = null;
    };
    document.body.appendChild(lessStyleNode);
    document.body.appendChild(lessConfigNode);
    document.body.appendChild(lessScriptNode);
    lessNodesAppended = true;
  } else {
    buildIt();
  }
};

const updateColorWeak = colorWeak => {
  document.body.className = colorWeak ? 'colorWeak' : '';
};

export default {
  namespace: 'setting',
  state: defaultSettings,
  effects: {
    *initOwl({ payload }, { put, select }) {
      const currentUser = yield select(state => state.user.currentUser);
      initOwl(currentUser);
    },
    *initHorn({ payload }, { put, select }) {
      const currentUser = yield select(state => state.user.currentUser);
      Horn.init({ id: currentUser?.login || '' }, { isDev: _ENVIRONMENT !== 'product' });
      yield yield put({
        type: 'fetchHorn',
        payload: {
          key: 'globalConfig',
          defaultValue: {
            pollingLocationInterval: 10000,
          },
        },
      });
      yield put({ type: 'initHornFinished' });
    },
    *initApi({ payload }, { put, select }) {
      const query = new URLSearchParams(window.location.search);
      let clientType = query.get('client');

      if (window.location.host.startsWith('apollo.')) {
        clientType = 'apolloPc';
      } else if (!['wmcrm', 'apolloPc', 'hotelPc'].includes(clientType)) {
        clientType = 'mdc';
      }
      yield put({
        type: 'updateUtmSource',
        payload: clientType,
      });
    },
    *fetchHorn({ payload }, { call, put }) {
      const { key, config = {}, defaultValue = null } = payload;
      yield put({ type: 'updateHorn', payload: { [key]: defaultValue } });
      const hornFetch = () => {
        return Horn.fetch(key, config, defaultValue);
      };
      const value = yield call(hornFetch);
      yield put({ type: 'updateHorn', payload: { [key]: value } });
    },
  },
  reducers: {
    initHornFinished(state) {
      return produce(state, draft => {
        draft.hornInit = true;
      });
    },
    updateHorn(state, { payload }) {
      return produce(state, draft => {
        Object.keys(payload).forEach(key => {
          draft.hornValue[key] = payload[key];
        });
      });
    },
    updateUtmSource(state, { payload }) {
      if (!payload) return state;
      window.mdcUtmSource = payload;
      // 设置 appnm：apolloPc 环境为 dp_apollo_pc，其他环境保持原值或默认为 mdc
      window.mdcAppnm = payload === 'apolloPc' ? 'dp_apollo_pc' : payload || 'mdc';
      return produce(state, draft => {
        draft.utmSource = payload;
      });
    },
    getSetting(state) {
      const setting = {};
      const urlParams = new URL(window.location.href);
      Object.keys(state).forEach(key => {
        if (urlParams.searchParams.has(key)) {
          const value = urlParams.searchParams.get(key);
          setting[key] = value === '1' ? true : value;
        }
      });
      const { primaryColor, colorWeak } = setting;
      if (state.primaryColor !== primaryColor) {
        updateTheme(primaryColor);
      }
      updateColorWeak(colorWeak);
      return {
        ...state,
        ...setting,
      };
    },
    changeSetting(state, { payload }) {
      const urlParams = new URL(window.location.href);
      Object.keys(defaultSettings).forEach(key => {
        if (urlParams.searchParams.has(key)) {
          urlParams.searchParams.delete(key);
        }
      });
      Object.keys(payload).forEach(key => {
        if (key === 'collapse') {
          return;
        }
        let value = payload[key];
        if (value === true) {
          value = 1;
        }
        if (defaultSettings[key] !== value) {
          urlParams.searchParams.set(key, value);
        }
      });
      const { primaryColor, colorWeak } = payload;
      if (state.primaryColor !== primaryColor) {
        updateTheme(primaryColor);
      }
      updateColorWeak(colorWeak);
      window.history.replaceState(null, 'setting', urlParams.href);
      return {
        ...state,
        ...payload,
      };
    },
  },
};
